<template lang="pug">
div(
    :class="classes"
    class="tl-position"
)
    slot
</template>

<script setup>
import { computed, inject } from 'vue'
import { getInjects } from '@/components/$tl/utils/injects'

const props = defineProps({
    x: String,
    y: String,
    column: Boolean,
    noWrap: Boolean,
})

const injects = getInjects(props, inject)

const x = computed(() => props.x ?? injects.x?.value)
const y = computed(() => props.y ?? injects.y?.value)
const column = computed(() => props.column ?? injects.column?.value)

const getFlex = (positionName, reversed) => {
    if (!reversed) {
        if (column.value) return x.value === positionName
        return y.value === positionName
    }
    if (column.value) {
        return y.value === positionName
    }
    return x.value === positionName
}

const classes = computed(() => {
    const out = []
    // X
    if (getFlex('center', false)) out.push('align-center')
    if (getFlex('end', false)) out.push('align-end')
    if (getFlex('start', false)) out.push('align-start')
    if (getFlex('stretch', false)) out.push('align-space-between')
    if (getFlex('space', false)) out.push('align-space-around')

    // Y
    if (getFlex('center', true)) out.push('justify-center')
    if (getFlex('end', true)) out.push('justify-end')
    if (getFlex('start', true)) out.push('justify-start')
    if (getFlex('stretch', true)) out.push('justify-space-between')
    if (getFlex('space', true)) out.push('justify-space-around')

    // REVERSED
    if (column.value) out.push('flex-column')

    if (props.noWrap) out.push('flex-no-wrap')

    return out
})
</script>

<style lang="sass" scoped>
.tl-position
    display: flex
    flex-wrap: wrap
</style>
